import moment from "moment";

interface Config {
  dateFormat: string;
  hoje?: string;
  ontem?: string;
  alwaysShowYear?: boolean;
}

const defaultConfig: Config = {
  hoje: "Hoje",
  ontem: "Ontem",
  dateFormat: "DD/MM/YYYY",
  alwaysShowYear: true,
};

export function formatDateOntemHoje(
  date: string,
  config: Config = defaultConfig
) {
  if (moment(date).isSame(moment(), "day")) {
    return config.hoje || defaultConfig.hoje;
  }

  if (moment(date).isSame(moment().subtract(1, "day"), "day")) {
    return config.ontem || defaultConfig.ontem;
  }

  const currentYear = moment().format("YYYY");

  if (currentYear === moment(date).format("YYYY") && !config.alwaysShowYear) {
    return moment(date).format('DD/MM');
  }

  return moment(date).format(config.dateFormat);
}
